<template>
	<step
		name="select-format"
		:title="title"
		valid>
		<template slot="title">
			<div class="grid">
				<div class="cell cell--fit">
					<template v-if="check.hasSelectedFormat">
						<div class="h5 configurator-step__title cursor-pointer" @click="setStepActive('select-format')">
							<span
								class="configurator-step__count configurator-step__count--valid"
								v-if="selectedFormat.productSize.fullName" />
							<span v-else class="configurator-step__count">1</span>
							Formaat
							<span class="configurator-step__semi-colon configurator-step__not-active-mobile">:</span>
							<span class="configurator-step__item configurator-step__not-active-mobile">
								{{ selectedFormat.productSize.fullName }}
							</span>
						</div>
					</template>
					<template v-else>
						<div class="h5 configurator-step__title">
							<span class="configurator-step__count">1</span>
							{{ title }}
						</div>
					</template>
				</div>
			</div>
		</template>

		<div class="alertbox alertbox--error alertbox mb-l" v-if="configuratorType.isConfiguration">
			<svg class="alertbox__icon alertbox__icon--error">
				<use xlink:href="#alert--error" />
			</svg>
			<p class="alertbox__text">
				<strong>Let op:</strong>
				Het aanpassen van een formaat is niet mogelijk.
				Doorloop hiervoor de stappen voor dit product opnieuw.
			</p>
		</div>

		<div
			class="alertbox alertbox--warning alertbox mb-l"
			v-if="uploadsAreComplete && hasMultipleSpecificationMatches">
			<svg class="alertbox__icon alertbox__icon--warning">
				<use xlink:href="#alert--warning" />
			</svg>
			<p class="alertbox__text">
				<strong>Let op:</strong>
				Uw upload past bij meerdere formaten.
				Selecteer uit onderstaande lijst handmatig uw gewenste formaat.
			</p>
		</div>

		<template v-if="!configuratorType.isConfiguration">

			<div class="configurator-options grid grid--gutters-s grid--1-5 grid--l-1-4 grid--ms-1-2">

				<template v-if="!hasMultipleSpecificationMatches">
					<format-option
						v-for="(format, index) in availableFormats" :key="index"
						:option="format"
						:disabled="uploadsAreComplete" />
				</template>
				<template v-else>
					<format-option
						v-for="(format, index) in specificationMatches" :key="index"
						:option="format" />
				</template>
			</div>

			<format-custom v-if="check.hasSelectedFormat && selectedFormat.isCustomSize && !uploadsAreComplete" />

		</template>
	</step>
</template>

<script>
import step from "@/components/step/step";
import formatOption from "@/components/format/format-option";
import formatCustom from "@/components/optional/format-custom";
import pageCount from "@/components/optional/page-count";

export default {
	name: "Format",
	components: {
		step,
		formatOption,
		formatCustom,
		pageCount
	},
	computed: {
		configuratorType () {
			return this.$store.getters.getConfiguratorType;
		},
		check () {
			return this.$store.getters.checkData;
		},
		selectedFormat () {
			return this.$store.getters.getSelectedFormat;
		},
		availableFormats () {
			return this.$store.getters.getAvailableFormats;
		},
		specificationMatches () {
			return this.$store.getters.getFormatMatches;
		},
		getCustomSizeValid () {
			return this.$store.getters.getCustomSizeValid;
		},
		getConfiguratorData () {
			return this.$store.getters.getConfiguratorData;
		},
		hasSeparateCover () {
			return this.$store.getters.hasSeparateCover;
		},
		hasMultipleSpecificationMatches () {
			return this.getConfiguratorData.hasFormatMatches;
		},
		title () {
			return this.$store.getters.uploadsAreComplete && !this.hasMultipleSpecificationMatches
				? "Dit is uw bestand"
				: "Kies een formaat";
		},
		uploadsAreComplete () {
			return this.$store.getters.uploadsAreComplete;
		},
		printSidesCountChoice () {
			return this.$store.getters.isPrintSidesCountChoice;
		},
		formatDescription () {
			return this.$store.getters.getSelectedFormatDescription;
		},
		getUniqueOrientations () {
			return this.$store.getters.getUniqueOrientations;
		},
		showOrientation () {
			return this.$store.getters.showOrientation;
		},
		getDictionary () {
			return this.$store.getters.getDictionary;
		},
		getSvg () {
			return this.$store.getters.getSvg;
		}
	},
	methods: {
		orientationLegend (orientations, hasSelectedFormat) {
			const both = orientations.includes(0);
			const portrait = orientations.includes(1);
			const landscape = orientations.includes(2);

			let result = "<div class=\"orientation-indicator configurator-step__title\">";

			const { svg, name } = (() => {
				if (both) {
					return {
						svg: this.getSvg.orientation.both,
						name: "Staand en liggend"
					};
				} else if (portrait) {
					return {
						svg: this.getSvg.orientation.portrait,
						name: "Staand"
					};
				} else if (landscape) {
					return {
						svg: this.getSvg.orientation.landscape,
						name: "Liggend"
					};
				}
			})();

			if (svg) {
				result += `<div class="orientation orientation--relative orientation--indicator">${svg}</div>`;
			}

			if (name) {
				result += (
					`<span class="orientation-indicator__text">
						${name} ${(!hasSelectedFormat ? "mogelijk " : "")}
					</span>`
				);
			}

			result += "</div>";

			return result;
		},
		emptyCustomSize () {
			this.$store.commit("SET_CUSTOM_SIZE", { width: null, height: null });
		},
		stepExists (stepToCheck) {
			return this.$store.getters.getStepExists(stepToCheck);
		},
		setStepActive (step) {
			if (this.stepExists(step).bool) {
				this.$store.commit("SET_STEP_ACTIVE", step);
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/format/format.vue